import React, { useState } from "react";
import { MdOutlineEmail } from "react-icons/md";
import { apiPostPut } from "../../api/api_methods";
import { IoIosCloseCircleOutline } from "react-icons/io";
// import { apiPostPut } from "../../services/api";

const ExportApplicant = ({ onClose, jdId }) => {
  const currentDate = new Date().getTime();
  const [resumeType, setResumeType] = useState("All resumes");
  const [dateRange, setDateRange] = useState("");
  const [scoreRange, setScoreRange] = useState("");
  // const [experienceRange, setExperienceRange] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(currentDate);
  const [minScore, setMinScore] = useState("");
  const [maxScore, setMaxScore] = useState("");
  // const [minExperience, setMinExperience] = useState("");
  // const [maxExperience, setMaxExperience] = useState("");
  const [assessmentType, setAssessmentType] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [resumes, setResumes] = useState([]);
  const [selectedResumes, setSelectedResumes] = useState();
  const [exportFormat, setExportFormat] = useState("Xls");
  const [isCustomDate, setIsCustomDate] = useState(true);
  const [isCustomScore, setIsCustomScore] = useState(true);

  const [currentTab, setCurrentTab] = useState(-1);
  const [selectedExport, setSelectedExport] = useState();
  const [resumesData, setResumesData] = useState();
  const ExportFormat = [
    { name: "Pdf", action: () => setCurrentTab(0), id: 0 },
    { name: "Xls", action: () => setCurrentTab(1), id: 1 },
    { name: "Csv", action: () => setCurrentTab(2), id: 2 },
    { name: "Json", action: () => setCurrentTab(3), id: 3 },
  ];

  console.log(exportFormat);

  const handleDateRangeChange = (e) => {
    const value = e.target.value;

    if (value === "custom") {
      setIsCustomDate(true);
    } else if (value === "lastWeek") {
      // getting the date of last week
      const lastWeek = currentDate - 7 * 24 * 60 * 60 * 1000;
      setStartDate(lastWeek);
      setEndDate(currentDate);
      setIsCustomDate(false);
    } else if (value === "last15Days") {
      // getting the date of last 15 days
      const last15Days = currentDate - 15 * 24 * 60 * 60 * 1000;
      setStartDate(last15Days);
      setEndDate(currentDate);
      setIsCustomDate(false);
    } else if (value === "last30Days") {
      // getting the date of last 30 days
      const last30Days = currentDate - 30 * 24 * 60 * 60 * 1000;
      setStartDate(last30Days);
      setEndDate(currentDate);
      setIsCustomDate(false);
    } else {
      setStartDate(null);
      setEndDate(currentDate);
      setIsCustomDate(false);
    }
  };

  const handleScoreRangeChange = (e) => {
    const value = e.target.value;
    if (value === "custom") {
      setIsCustomScore(true);
    } else {
      setIsCustomScore(false);
    }
  };

  const user = JSON.parse(localStorage.getItem("user"));

  const handleExport = async () => {
    console.log(assessmentType, "assessmentType");
    const payload = {
      assessmentType,
      statusFilter,
      minScore: minScore !== "" ? Number(minScore) : "",
      maxScore: maxScore !== "" ? Number(maxScore) : "",
      // minExperience,
      // maxExperience,
      startDate: startDate ? new Date(startDate).getTime() : "",
      endDate: endDate ? new Date(endDate).getTime() : "",
    };
    //   on export payload

    console.log(payload);
    console.log("this is the view", selectedExport);

    const response = await apiPostPut(
      payload,
      `/company-dashboard/company-applicants-data/${user?._id}`,
      "POST"
    );

    // filter according to the payload and export the data

    setResumesData(response.body.data);
    if (exportFormat === "Csv") {
      exportToCsv(response.body.data);
    } else if (exportFormat === "Json") {
      exportToJson(response.body.data);
    } else if (exportFormat === "Xls") {
      exportToExcel(response.body.data);
    } else {
      alert("Pdf export is Comming Soon...");
    }
    // exportToPDF(response.body.resumesData);

    console.log(response.body.data);
  };

  const exportToPDF = (response) => {
    if (!Array.isArray(response)) {
      console.error("Response is not an array or is undefined.");
      return;
    }
    // convert the csv file to pdf
    const headers = new Set();
    response.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (Array.isArray(item[key])) {
          // Add keys for nested arrays
          headers.add(key);
        } else {
          headers.add(key);
        }
      });
    });

    // Convert headers to an array and prepare the CSV header row
    const headerArray = Array.from(headers);
    let CsvString = headerArray.join(",") + "\n";

    // Process each object in the response
    response.forEach((item) => {
      const row = headerArray.map((header) => {
        const value = item[header];

        if (Array.isArray(value)) {
          // Handle nested arrays (e.g., skills, projects)
          if (header === "skills") {
            return value.map((skill) => skill.skill).join("; ");
          } else if (header === "projects") {
            return value
              .map(
                (project) =>
                  `${project.title} (${project.techStackUsed.join(", ")})`
              )
              .join("; ");
          } else if (header === "match") {
            return value
              .map(
                (match) =>
                  `Score: ${match.score}, Suggestion: ${match.suggestion}`
              )
              .join("; ");
          } else {
            return value.join("; "); // Generic handling for other arrays
          }
        } else if (value && typeof value === "object") {
          // Handle nested objects
          return JSON.stringify(value);
        } else {
          // Handle primitive values
          return value !== undefined && value !== null ? `"${value}"` : "";
        }
      });

      CsvString += row.join(",") + "\n";
    });

    // Create a downloadable csv to pdf file
    const encodedUri =
      "data:text/csv;charset=utf-8," + encodeURIComponent(CsvString);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Applicants.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up after download
  };

  const exportToJson = (response) => {
    if (!Array.isArray(response)) {
      console.error("Response is not an array or is undefined.");
      return;
    }
    const jsonString = JSON.stringify(response, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Applicants.json";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up after download
  };

  const exportToCsv = (response) => {
    if (!Array.isArray(response)) {
      console.error("Response is not an array or is undefined.");
      return;
    }

    // Extract all unique keys from the objects (including nested keys)
    const headers = new Set();
    response.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (Array.isArray(item[key])) {
          // Add keys for nested arrays
          headers.add(key);
        } else {
          headers.add(key);
        }
      });
    });

    // Convert headers to an array and prepare the CSV header row
    const headerArray = Array.from(headers);
    let CsvString = headerArray.join(",") + "\n";

    // Process each object in the response
    response.forEach((item) => {
      const row = headerArray.map((header) => {
        const value = item[header];

        if (Array.isArray(value)) {
          // Handle nested arrays (e.g., skills, projects)
          if (header === "skills") {
            return value.map((skill) => skill.skill).join("; ");
          } else if (header === "projects") {
            return value
              .map(
                (project) =>
                  `${project.title} (${project.techStackUsed.join(", ")})`
              )
              .join("; ");
          } else if (header === "match") {
            return value
              .map(
                (match) =>
                  `Score: ${match.score}, Suggestion: ${match.suggestion}`
              )
              .join("; ");
          } else {
            return value.join("; "); // Generic handling for other arrays
          }
        } else if (value && typeof value === "object") {
          // Handle nested objects
          return JSON.stringify(value);
        } else {
          // Handle primitive values
          return value !== undefined && value !== null ? `"${value}"` : "";
        }
      });

      CsvString += row.join(",") + "\n";
    });

    // Create a downloadable CSV file
    const encodedUri =
      "data:text/csv;charset=utf-8," + encodeURIComponent(CsvString);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Applicants.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up after download
  };

  const exportToExcel = (response) => {
    if (!Array.isArray(response)) {
      console.error("Response is not an array or is undefined.");
      return;
    }

    if (response.length === 0) {
      console.error("Response array is empty.");
      return;
    }

    // Prepare the Excel XML header
    let excelFile = `
            <?xml version="1.0"?>
            <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
                      xmlns:o="urn:schemas-microsoft-com:office:office"
                      xmlns:x="urn:schemas-microsoft-com:office:excel"
                      xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">
              <Worksheet ss:Name="Resumes">
                <Table>
        `;

    // Add headers dynamically based on all keys in the first object
    const headers = Object.keys(response[0]);
    excelFile += "<Row>";
    headers.forEach((header) => {
      excelFile += `<Cell><Data ss:Type="String">${header}</Data></Cell>`;
    });
    excelFile += "</Row>";

    // Add data rows
    response.forEach((item) => {
      excelFile += "<Row>";
      headers.forEach((header) => {
        let value = item[header];

        if (Array.isArray(value)) {
          // Handle arrays (e.g., skills, projects)
          if (header === "skills") {
            value = value.map((skill) => skill.skill).join("; ");
          } else if (header === "projects") {
            value = value
              .map(
                (project) =>
                  `${project.title} (${project.techStackUsed.join(", ")})`
              )
              .join("; ");
          } else if (header === "match") {
            value = value
              .map(
                (match) =>
                  `Score: ${match.score}, Suggestion: ${match.suggestion}`
              )
              .join("; ");
          } else {
            value = value.join("; "); // Generic handling for other arrays
          }
        } else if (value && typeof value === "object") {
          // Handle objects
          value = JSON.stringify(value);
        }

        // Ensure null or undefined values are empty strings
        value = value !== undefined && value !== null ? value : "";

        excelFile += `<Cell><Data ss:Type="String">${value}</Data></Cell>`;
      });
      excelFile += "</Row>";
    });

    // Close the XML tags
    excelFile += `
                </Table>
              </Worksheet>
            </Workbook>
        `;

    // Create a downloadable file
    const blob = new Blob([excelFile], { type: "application/vnd.ms-excel" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Applicants.xls";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up after download
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black backdrop-blur-sm bg-opacity-50">
      <form
        className="bg-white p-8 pr-8 md:pl-20 rounded-lg w-[90vw]  max-w-[90vw] sm:max-w-[90vw] sm:w-fit sm:min-w-[50vw] md:w-[60vw] lg:w-[40vw] h-fit max-h-[90vh] overflow-y-auto"
        onSubmit={async (e) => {
          e.preventDefault();

          if (assessmentType === "") {
            alert("Please select assessment type");
            return;
          }
          if (dateRange === "custom" && (startDate === "" || endDate === "")) {
            alert("Please select start and end date");
            return;
          }
          if (scoreRange === "custom" && (minScore === "" || maxScore === "")) {
            alert("Please select min and max score");
            return;
          }

          await handleExport();

          if (!resumesData || resumesData.length === 0) {
            alert("No data available for the selected filters");
            return;
          }

          onClose();
        }}
      >
        {/* Header */}
        <div className="flex items-center mb-6  relative">
          <button
            type="button"
            className="absolute text-primary -top-6 -right-6  "
            onClick={onClose}
          >
            <IoIosCloseCircleOutline size={24} />
          </button>
          <div className="w-10 h-10 bg-primary2 rounded-full flex items-center  justify-center mr-4">
            <MdOutlineEmail size={22} />
          </div>
          <h2 className="text-xl font-semibold text-gray-800">
            Export Applicants
          </h2>
        </div>

        {/* Form */}
        <div className="space-y-6 w-full">
          {/* Resume Type and Assessment Type */}
          <div className="-mb-1">
            <label
              className="block text-sm font-semibold mb-2 mt-4 "
              htmlFor="assessmentType"
            >
              Select assessment
            </label>
            <select
              id="assessmentType"
              required
              value={assessmentType}
              onChange={(e) => setAssessmentType(e.target.value)}
              className="border border-gray-300 w-full sm:w-[90%]  text-primary rounded-lg p-2"
            >
              <option value="">Select Assessment</option>
              <option value="all">All Resumes</option>
              <option value="mocktest">mocktest</option>
              <option value="interview">interview</option>
              <option value="jobpost">jobPost</option>
              <option value="resumeSorting">resumeSorting</option>
            </select>
          </div>

          {/* Date Range and Score Range */}
          <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-1">
            {/* Date Range */}
            <div className="w-full md:w-[45%]">
              <label
                className="block text-sm font-semibold  text-black"
                htmlFor="dateRange"
              >
                Date Range
              </label>
              <div className="mt-1">
                <select
                  id="dateRange"
                  className="block w-full sm:w-[90%]  px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                  required
                  value={dateRange}
                  onChange={(e) => {
                    setDateRange(e.target.value);
                    if (e.target.value === "custom") setIsCustomDate(true);
                    else setIsCustomDate(false);

                    switch (e.target.value) {
                      case "all":
                        setStartDate();
                        setEndDate("currentDate");
                        break;
                      case "last week":
                        setStartDate(currentDate - 7 * 24 * 60 * 60 * 1000);
                        setEndDate(currentDate);
                        break;
                      case "last15days":
                        setStartDate(currentDate - 15 * 24 * 60 * 60 * 1000);
                        setEndDate(currentDate);
                        break;
                      case "last30days":
                        setStartDate(currentDate - 30 * 24 * 60 * 60 * 1000);
                        setEndDate(currentDate);
                        break;
                      case "custom":
                        setStartDate("");
                        setEndDate("");
                        break;
                      default:
                        break;
                    }
                  }}
                >
                  <option value="">Select dates</option>
                  <option value="all">All dates</option>
                  <option value="last week">Last week</option>
                  <option value="last15days">Last 15 days</option>
                  <option value="last30days">Last 30 days</option>
                  <option value="custom">Custom dates</option>
                </select>

                {dateRange === "custom" && (
                  <div className="flex space-x-2 mt-2">
                    <input
                      type="date"
                      required
                      className="block w-1/2 px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                    <input
                      type="date"
                      required
                      className="block w-1/2 px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Score Range */}
            <div className="w-full md:w-[50%]">
              <label
                className="block text-sm font-semibold text-black"
                htmlFor="scoreRange"
              >
                Score Range
              </label>
              <div className="mt-1">
                <select
                  id="scoreRange"
                  className="block w-full sm:w-[90%]  px-3 py-2  border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                  required
                  value={scoreRange}
                  onChange={(e) => {
                    setScoreRange(e.target.value);

                    if (e.target.value === "custom") setIsCustomScore(true);
                    else setIsCustomScore(false);

                    switch (e.target.value) {
                      case "all":
                        setMinScore(0);
                        setMaxScore(100);
                        break;
                      case "above 90":
                        setMinScore(90);
                        setMaxScore(100);
                        break;
                      case "70-89":
                        setMinScore(70);
                        setMaxScore(89);
                        break;
                      case "less than 70":
                        setMinScore(0);
                        setMaxScore(69);
                        break;
                      case "custom":
                        setMinScore("");
                        setMaxScore("");
                        break;
                      default:
                        break;
                    }
                  }}
                >
                  <option value="">Select Score</option>
                  <option value="all">All scores</option>
                  <option value="above 90">Above 90%</option>
                  <option value="70-89">70%-89%</option>
                  <option value="less than 70">Less than 70%</option>
                  <option value="custom">Custom score</option>
                </select>

                {scoreRange === "custom" && (
                  <div className="flex space-x-2 mt-2">
                    <input
                      type="number"
                      required
                      className="block w-1/2 px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                      value={minScore}
                      onChange={(e) => setMinScore(e.target.value)}
                      placeholder="Min score"
                    />
                    <input
                      type="number"
                      required
                      className="block w-1/2 px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                      value={maxScore}
                      onChange={(e) => setMaxScore(e.target.value)}
                      placeholder="Max score"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Select Candidates */}
          <div className="mb-4">
            <label className="block font-semibold - mb-1">
              Select Candidates
            </label>
            <div className="grid grid-cols-2 md:grid-cols-4 whitespace-nowrap gap-2">
              {["All", "Shortlisted", "On Hold", "Rejected"].map((status) => (
                <label
                  key={status}
                  className="flex items-center gap-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    name="candidateStatus"
                    className="accent-orange-600 w-4 h-4 cursor-pointer"
                    value={status}
                    checked={
                      statusFilter === status ||
                      (statusFilter === null && status === "All")
                    }
                    onChange={() => setStatusFilter(status)}
                  />
                  {status}
                </label>
              ))}
            </div>
          </div>

          {/* Export Format */}
          <div>
            <label
              className="block text-sm font-semibold  text-black mb-2"
              htmlFor="exportFormat"
            >
              Select Export Format
            </label>
            <div className="grid grid-cols-2 md:grid-cols-4 whitespace-nowrap gap-2 ">
              {["Xls", "Csv", "Json", "Pdf"].map((format) => (
                <label
                  key={format}
                  className={`cursor-pointer flex items-center justify-between w-[100px] px-4 py-2 border rounded-lg text-sm font-medium mb-2 md:mb-0 ${exportFormat === format
                      ? "border-orange-500 text-orange-500"
                      : "border-gray-300 text-black"
                    }`}
                >
                  <input
                    type="radio"
                    name="exportFormat"
                    id="exportFormat"
                    value={format}
                    checked={exportFormat === format}
                    onChange={() => setExportFormat(format)}
                    className="hidden"
                  />
                  <span>{format}</span>
                  <span
                    className={`ml-2 w-4 h-4 border-2 rounded-full flex items-center justify-center ${exportFormat === format
                        ? "border-orange-500"
                        : "border-gray-300"
                      }`}
                  >
                    {exportFormat === format && (
                      <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
                    )}
                  </span>
                </label>
              ))}
            </div>
          </div>

          {/* Export Button */}
          <div className="flex justify-start mr-10">
            <button
              type="submit"
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-2 rounded-md text-sm font-medium"
            >
              Export
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ExportApplicant;
